<template>
    <div>
        <!-- <header class="header">
            <div class="h_inner inner">
                <div class="h_left"></div>
                <div class="h_right">
                    <button type="button" class="btn clear_btn menu_btn" @click="openLModal()"></button>
                </div>
            </div>
        </header> -->
        <section class="section sec3">
            <div class="inner">
                <div class="titbox">
                    <p class="m_txt1 center">
                        지금까지 추첨된 생성번호와 <br>
                        당첨 결과를 소개합니다!
                    </p>
                </div>
                <div class="contbox">
                    <div class="item">
                        <div class="iconbox">
                            <img :src="`${$STATIC_URL}/user/img/ico_total.png`" alt="">
                        </div>
                        <div class="txtbox">
                            <p class="tit">총 생성번호</p>
                            <p class="desc">
                                <span class="number">{{ total_num }}</span>건
                            </p>
                        </div>
                    </div>
                    <div class="item">
                        <div class="iconbox">
                            <img :src="`${$STATIC_URL}/user/img/ico_3th.png`" alt="">
                        </div>
                        <div class="txtbox">
                            <p class="tit">3등 이상 당첨</p>
                            <p class="desc">
                                <span class="number">{{ third_num }}</span>건
                            </p>
                        </div>
                    </div>
                    <div class="item">
                        <div class="iconbox">
                            <img :src="`${$STATIC_URL}/user/img/ico_5th.png`" alt="">
                        </div>
                        <div class="txtbox">
                            <p class="tit">5등 이상 당첨</p>
                            <p class="desc">
                                <span class="number">{{ fifth_num }}</span>건
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section sec4">
            <div class="inner">
                <div class="titbox">
                    <p class="m_txt1 center">
                        What we research
                    </p>
                </div>
                <div class="personbox">
                    <p class="m_txt2 center bold tit">Benford's Law</p>
                    <p class="m_txt2 center desc">
                        어떤 집합에 속한 수들의 첫째 자리는 낮은 수일수록 <br>
                        출현 확률이 높고, 높은 수일수록 출현 확률이 낮다
                    </p>
                    <div class="person_info">
                        <img :src="`${$STATIC_URL}/user/img/frank_benford.png`" alt="" class="thum">
                        <p class="name">Frank_Benford</p>
                    </div>
                </div>
                <div class="infobox">
                    <p class="m_txt2 center bold tit">
                        TEAM_Favored Advanced Technologies
                    </p>
                    <p class="m_txt2 center desc">
                        우리는 Global 기업에 AI솔루션과 AI플랫폼을 <br>
                        개발하여 제공하고 있습니다. <br>
                        Number_Favored는 ‘벤포드의 법칙’을 포함한 자연 수 관련 <br>
                        Data Analysis와 AI 기술을 활용하여 개발되었습니다.
                    </p>
                </div>
            </div>
        </section>

        <section class="section sec5">
            <div class="inner">
                <div class="titbox">
                    <p class="m_txt1 center">
                        What is it?
                    </p>
                    <br />
                    <p class="m_txt2 center bold tit">
                        Number_Favored App
                    </p>
                    <p class="m_txt2 center desc">
                        로또 6/45 골드번호 추출을 위해 팀페이버드 부설연구소에서<br />
                        개발한 로직을 탑재한 앱으로 AI기반의 Big Data 분석을 통해<br />
                        최적의 번호 조합을 제공합니다.
                    </p>
                </div>
                <div class="contbox">
                    <div class="grid-container">
                        <div class="card blue-gradient">
                            <div class="card-text">가장 진보한<br>알고리즘</div>
                            <img :src="`${$STATIC_URL}/user/img/Bitmap.png`" alt="알고리즘 아이콘">
                        </div>
                        <div class="card purple-gradient">
                            <div class="card-text">방대한<br>Big Data 분석</div>
                            <img :src="`${$STATIC_URL}/user/img/Bitmap2.png`" alt="Big Data 아이콘">
                        </div>
                        <div class="card purple2-gradient">
                            <div class="card-text">Benford's Law &<br>Regression Analysis</div>
                            <img :src="`${$STATIC_URL}/user/img/Bitmap3.png`" alt="분석 아이콘" style="margin-top:5px">
                        </div>
                        <div class="card pink-gradient">
                            <div class="card-text">AI Solution &<br>AI Platform Company</div>
                            <img :src="`${$STATIC_URL}/user/img/Bitmap4.png`" alt="AI 플랫폼 아이콘" style="margin-top:5px">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import { getStatistics } from '@/api';
import { ref, onMounted } from 'vue';
// import { useStore } from 'vuex';
// const store = useStore();
// function openLModal() {
//     store.commit('setLeftModalState', true);
// }
let total_num = ref(0)
let third_num = ref(0)
let fifth_num = ref(0)

onMounted(async () => {
    let response = await getStatistics()
    total_num.value = response.data.all_num
    third_num.value = response.data.third_num
    fifth_num.value = response.data.fifth_num
});
</script>


<style scoped>
.grid-container {
    display: grid;
    grid-template-columns: repeat(2, calc(50% - 5px));
    grid-gap: 10px;
}

.card {
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    color: #000;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 158px;
}




.card img {
    width: 56px;
    height: 56px;
    margin-top: 15px;
    margin-left: auto;
}

.blue-gradient {
    background: linear-gradient(180deg, #B5CFFF 0%, #527AE2 100%);
}

.purple-gradient {
    background: linear-gradient(180deg, #B5B8FF 0%, #7952E2 100%);
}

.purple2-gradient {
    background: linear-gradient(180deg, #CFB5FF 0%, #A052E2 100%);
}

.pink-gradient {
    background: linear-gradient(180deg, #F7B5FF 0%, #CB52E2 100%);
}

.card-text {
    font-size: 16px;
    font-weight: bold;
    line-height: 1.5;
}
</style>